import React, { useState } from "react";
import { graphql, Link } from "gatsby";
import WhatChooseUs from "components/homepage/whyChooseUs";
import QuotePopUp from "components/popup/quotePopUp/index";
import GetInTouch from "components/getInTouch";
import MidText from "./midText";
import Layout from "components/layout";
import SEO from "components/seo";
import OptimizedImage from "hooks/OptimizedImage";

export const recentQuery = graphql`
  query recentQuery($limit: Int!, $skip: Int!) {
    allRecentPages(sort: { fields: [data___seo_project_create_date], order: DESC }, limit: $limit, skip: $skip) {
      edges {
        node {
          data {
            seo_h1
            seo_project_create_date
            seo_project_small_desc
            slug
          }
        }
      }
    }
  }
`;

export default function RecentTranslation(props) {
  const [open, setOpen] = useState(false);

  const title = "Last Translation Projects - Case Studies - Tomedes";
  const description = "Recent translation projects and case studies by Tomedes – We've worked with over 95,000 customers and have a satisfaction rating of 97%.";
  const keywords = "Recent translations, case studies, translation services";
  const recentPagesData = props.data.allRecentPages.edges;
  const totalPages = props.pageContext.totalPages;
  const currentPage = props.pageContext.currentPage;
  var canonical = "/recent-translations.php";
  if (props.pageContext.currentPage !== 1) {
    canonical = "/recent-translations.php/p/" + props.pageContext.currentPage;
  }

  return (
    <Layout>
      <SEO title={title} description={description} keywords={keywords} slug={canonical} />
      <div className="bannerImage recent-bg bg-no-repeat bg-cover bg-center text-white pb-36">
        <div className=" mx-auto  pb-8 sm:w-[90%] w-[80%] pt-20 lg:max-w-7xl">
          <h1 className="text-[22px] sm:text-[40px] md:text-[48px] lg:text-60 bg-contact-img custom-bg-pos bg-no-repeat leading-[40px] lg:leading-[60px] inline-block font-medium w-auto lg:w-max font-riot custom-bg-h1">
            Last translation projects
          </h1>
          <br />
          <div className="bg-black bg-opacity-50 bg-no-repeat px-4 font-primary text-[14px] sm:text-2xl mt-7 inline-flex flex-col lg:flex-row gap-4 lg:gap-5 lg:items-center lg:mt-7">
            <div className="flex items-center">
            <OptimizedImage
                      src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                      alt={""}
                      className="w-6 h-6 mr-4"
                    />
              <span className="">24/7 Human Support</span>
            </div>
            <div className="flex items-center">
            <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
              />
              <span className="">1 Year Guarantee</span>
            </div>
            <div className="flex items-center">
            <OptimizedImage
                src="https://tomedes.gumlet.io/frontend/images/banner/check_sign.svg"
                alt={""}
                className="w-6 h-6 mr-4"
              />
              <span className="content-left">95,000 Business Customers</span>
            </div>
          </div>
          <div className="grid grid-cols-1 py-6 space-y-6 text-center md:flex md:flex-row md:align-baseline md:items-center md:space-x-6 md:space-y-0 font-opensans mt-7">
            <Link
              to="/quote"
              className="fr-btn1 tomedes-button green-btn-hv text-new ruppercase rounded-full py-4 bg-orange text-white text-sm cursor-pointer w-60  font-semibold font-primary hover:bg-[#ff9a16] transition-colors duration-300"
            >
              Get a Free Quote
            </Link>
            <a
              onClick={() => setOpen(true)}
              className="hidden sm:inline-block fr-btn2 tomedes-button uppercase rounded-full bg-white py-4 text-black text-sm  cursor-pointer w-60 font-semibold font-primary "
            >
              Contact Us
            </a>
            <Link to="/contactus.php" className="sm:hidden fr-btn2 tomedes-button uppercase rounded-full bg-white py-4 text-black text-sm  cursor-pointer w-60 font-semibold font-primary ">
              Contact us
            </Link>
          </div>
        </div>
      </div>
      <QuotePopUp open={open} setOpen={setOpen} />
      <MidText recentPagesData={recentPagesData} totalPages={totalPages} currentPage={currentPage} />
      {/* <WhatChooseUs backgroundCol="bg-darkBlue" /> */}
      <GetInTouch />
    </Layout>
  );
}
